import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import Chat from "../assets/chat.svg";
import Mail from "../assets/mail.svg";
import Phone from "../assets/phone.svg";
import WhatsApp from "../assets/whats-app.svg";
import styles from "./social-link.module.css";
import { useCallback } from "react";
const getIcon = (label)=>{
    switch(label){
        case "WhatsApp":
            {
                return /*#__PURE__*/ _jsx(WhatsApp, {});
            }
        case "Text us":
            {
                return /*#__PURE__*/ _jsx(Chat, {});
            }
        case "Call us":
            {
                return /*#__PURE__*/ _jsx(Phone, {});
            }
        case "Email us":
            {
                return /*#__PURE__*/ _jsx(Mail, {});
            }
        default:
            return;
    }
};
const SocialLink = ({ name , linkLabel , href , trackingEvent , target  })=>{
    const { trackEvent  } = useAnalytics();
    const onSocialLinkClick = useCallback(()=>{
        if (trackingEvent) {
            trackEvent(trackingEvent);
        }
    }, [
        trackingEvent
    ]);
    return /*#__PURE__*/ _jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/ _jsxs("a", {
            href: href,
            className: styles.link,
            onClick: onSocialLinkClick,
            rel: "noopener noreferrer",
            target: target,
            children: [
                /*#__PURE__*/ _jsxs(Text, {
                    className: styles.body,
                    fontSize: "s",
                    lineHeight: "body",
                    fontWeight: "semibold",
                    children: [
                        getIcon(name),
                        /*#__PURE__*/ _jsx("span", {
                            className: styles.iconName,
                            children: name
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Text, {
                    className: styles.linkLabel,
                    children: linkLabel
                })
            ]
        })
    });
};
export default SocialLink;
